import { Badge } from '@/components/ui/badge.js';
import { ReactNode } from 'react';

interface GroupDividerLayoutProps {
  rowCount: number;
  children: ReactNode;
}

export function GroupDividerLayout({ rowCount, children }: GroupDividerLayoutProps) {
  return (
    <span className="flex min-w-0 items-center gap-2 text-sm pl-3">
      <span className="min-w-0 break-words">{children}</span>
      <Badge variant="secondary" className="shrink-0 bg-air-blue-subdued hover:bg-air-blue-subdued text-air-dark-blue">
        {rowCount}
      </Badge>
    </span>
  );
}
